import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SessionGuard } from './guards/session/session.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/login-page/login-page.module').then((m) => m.LoginPageModule),
        canActivate: [SessionGuard],
    },
    {
        path: 'onboarding',
        loadChildren: () => import('./pages/onboarding-page/onboarding-page.module').then((m) => m.OnboardingPageModule),
    },
    {
        path: 'forgot-password',
        loadChildren: () =>
            import('./pages/forgot-password-page/forgot-password-page.module').then((m) => m.ForgotPasswordPageModule),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
